import { faSpinner } from '@fortawesome/pro-solid-svg-icons'

import { Icon } from 'Components/Icon/Icon'

export const AppLoader = () => (
  <div className="page-loading-container d-flex align-items-center justify-content-center">
    <Icon icon={faSpinner} size={50} spin />
  </div>
)
